export const sortViews = (views: ViewCount[]) =>
  [...views].sort((a, b) => new Date(b.last_viewed_at).getTime() - new Date(a.last_viewed_at).getTime());
